import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import colors from 'styles/colors'
import { type AnalyticsContentFeedCard } from 'types/api/analytic'

interface FeedAnalyticsCardDropdownProps {
    card: AnalyticsContentFeedCard
}
export function FeedAnalyticsCardDropdown({
    card
}: FeedAnalyticsCardDropdownProps) {
    const { t } = useTranslation()
    return (
        <DropdownWrapper>
            <InfoContainer>
                <InfoType>{t('overallRevenue')}</InfoType>
                <InfoValue>{'$' + (card.overall_revenue ? card.overall_revenue.toFixed(2) : '0.00')}</InfoValue>
                </InfoContainer>
            {card?.purchases > 0 && (
                <InfoContainer>
                    <InfoType>{t('purchases')}</InfoType>
                    <InfoValue>{`$${card.purchases ? card.purchases.toFixed(2) : '0.00'}`}</InfoValue>
                    </InfoContainer>
            )}
            <InfoContainer>
                <InfoType>{t('purchases_count')}</InfoType>
                <InfoValue>{card.purchases_count}</InfoValue>
            </InfoContainer>
            <InfoContainer>
                <InfoType>{t('tips')}</InfoType>
                <InfoValue>{card.tips ? `$${card.tips}` : '0'}</InfoValue>
            </InfoContainer>
            <InfoContainer>
                <InfoType>{t('tips_count')}</InfoType>
                <InfoValue>{card.tips_count}</InfoValue>
            </InfoContainer>
            <InfoContainer>
                <InfoType>{t('mediaViews')}</InfoType>
                <InfoValue>{card.media_views}</InfoValue>
            </InfoContainer>
            <InfoContainer>
                <InfoType>{t('impressions')}</InfoType>
                <InfoValue>{card.impressions}</InfoValue>
            </InfoContainer>
            <InfoContainer>
                <InfoType>{t('likes')}</InfoType>
                <InfoValue>{card.likes}</InfoValue>
            </InfoContainer>
            <InfoContainer>
                <InfoType>{t('comments')}</InfoType>
                <InfoValue>{card.comments}</InfoValue>
            </InfoContainer>
            <InfoContainer>
                <InfoType></InfoType>
                <InfoValue></InfoValue>
            </InfoContainer>
            {card.videos.length !== 0 ? (
                <InfoContainer>
                    <InfoType>{t('videoCompletionRate')}</InfoType>
                    <InfoValue>{card.average_video_played}</InfoValue>
                </InfoContainer>
            ) : (
                ''
            )}
            <InfoContainer>
                <InfoType>{t('mediaViewsImpressionRate')}</InfoType>
                <InfoValue>{Math.round(card.media_views_impression_rate) + '%'}</InfoValue>
                {/* <InfoValue>{card.media_views_impression_rate + '%'}</InfoValue> */}
            </InfoContainer>
            {card?.purchases > 0 && (
                <>
                    <InfoContainer>
                        <InfoType>{t('purchaseImpressionRate')}</InfoType>
                        <InfoValue>{Math.round(card.purchase_impression_rate) + '%'}</InfoValue>
                    </InfoContainer>
                </>
            )}

        </DropdownWrapper>
    )
}

const DropdownWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0.5rem 2.5rem;
`

const InfoContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: 'Montserrat';
    font-style: normal;
    margin: 1rem 0;
`
const InfoType = styled.div`
    font-weight: 500;
    font-size: 1.2rem;
    color: #828c94;
`
const InfoValue = styled.div`
    font-weight: 700;
    font-size: 1.4rem;
    color: $blue-dark;
    transition: all ease-in-out 0.3s;
    &:hover {
        color: ${colors.blueLighter};
    }
`
